import { type FC } from 'react';

import { useSupportChatConfig } from 'dibs-support-chat/exports/useSupportChatConfig.ts';
import { SupportChatLazy } from 'dibs-support-chat/exports/SupportChatLazy.ts';

const SupportChat: FC = () => {
    const { config, shouldInitChat } = useSupportChatConfig();

    if (!shouldInitChat) {
        return null;
    }

    return <SupportChatLazy {...config} />;
};

export { SupportChat };
